import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "d5e396ea-6040-45d4-b241-cec045eeb81b",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText: "Input <b>sensitivity</b> (round to one decimal place)",
    suffixText: "mV/Pa",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 7.1,
};
